import {Component, Input, Output, EventEmitter, SimpleChanges, OnChanges} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ApplicationSchemeHistoryDTO} from '../../../../../../models/application/ApplicationSchemeHistoryDTO';
import {UtilService} from '../../../../../../../common/services/util.service';
import {UserAuthorisationService} from '../../../../../../../common/services/user-authorisation.service';
import {
  SchemeHistoryAddDialogComponent
} from '../../../../../dialogs/scheme-history-add-dialog/scheme-history-add-dialog.component';
import {
  ConfirmationDialogComponent
} from '../../../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-person-scheme-history',
  templateUrl: './person-scheme-history.component.html',
  styleUrls: ['./person-scheme-history.component.scss']
})
export class PersonSchemeHistoryComponent implements OnChanges {
  hasPermissions = false;

  @Input() schemeHistory: ApplicationSchemeHistoryDTO[];
  @Input() applicationPersonId: number;
  @Input() isApplicationLocked: boolean;

  @Output() schemeHistoryUpdated = new EventEmitter<{
    applicationPersonId: number;
    schemeHistory: ApplicationSchemeHistoryDTO;
    isEdit: boolean;
    isDelete?: boolean;
  }>();

  constructor(
    private utilService: UtilService,
    private dialog: MatDialog,
    private userAuthorisationService: UserAuthorisationService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isApplicationLocked) {
      this.isApplicationLocked = changes.isApplicationLocked.currentValue;
      this.setPermission();
    }
  }

  setPermission(): void {
    const hasRole = this.userAuthorisationService.hasOnBoardingQC() || this.userAuthorisationService.hasRoleEnterpriseManager();
    this.hasPermissions = hasRole && !this.isApplicationLocked;
  }

  getSchemeHistoryString(scheme: ApplicationSchemeHistoryDTO): string {
    return `${scheme?.scheme?.schemeName ?? 'Unknown'} - ${scheme.membershipNumber} -
            ${this.formatDate(scheme.startDate)} - ${this.formatDate(scheme.endDate)}`;
  }

  onAddSchemeHistory(): void {
    const dialogRef: MatDialogRef<SchemeHistoryAddDialogComponent> = this.dialog.open(SchemeHistoryAddDialogComponent, {
      width: '40vw',
      data: {
        applicationPersonId: this.applicationPersonId
      }
    });

    dialogRef.afterClosed().subscribe((newSchemeHistory: ApplicationSchemeHistoryDTO) => {
      if (newSchemeHistory) {
        this.schemeHistoryUpdated.emit({
          applicationPersonId: this.applicationPersonId,
          schemeHistory: newSchemeHistory,
          isEdit: false
        });
      }
    });
  }

  onEditSchemeHistory(schemeHistory: ApplicationSchemeHistoryDTO): void {
    const dialogRef: MatDialogRef<SchemeHistoryAddDialogComponent> = this.dialog.open(SchemeHistoryAddDialogComponent, {
      width: '40vw',
      data: {
        applicationPersonId: this.applicationPersonId,
        schemeHistory
      }
    });

    dialogRef.afterClosed().subscribe((updatedSchemeHistory: ApplicationSchemeHistoryDTO) => {
      if (updatedSchemeHistory) {
        this.schemeHistoryUpdated.emit({
          applicationPersonId: this.applicationPersonId,
          schemeHistory: updatedSchemeHistory,
          isEdit: true
        });
      }
    });
  }

  onDeleteSchemeHistory(schemeHistoryToDelete: ApplicationSchemeHistoryDTO): void {
    const confirmationMessage = `Are you sure you want to delete this ${this.getSchemeHistoryString(schemeHistoryToDelete)} scheme history?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: confirmationMessage
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.schemeHistoryUpdated.emit({
          applicationPersonId: this.applicationPersonId,
          schemeHistory: schemeHistoryToDelete,
          isEdit: false,
          isDelete: true
        });
      }
    });
  }

  private formatDate(date: Date | string): string {
    return date ? this.utilService.dateFormat(date) : null;
  }
}
